import { render, staticRenderFns } from "./supply-form-wrapper.vue?vue&type=template&id=1a6b5880&scoped=true"
import script from "./supply-form-wrapper.vue?vue&type=script&lang=js"
export * from "./supply-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b5880",
  null
  
)

export default component.exports